import { Spinner } from '@appcues/sonar';
import styled from 'styled-components';

const LoadingSpinner = styled.div.attrs({ children: <Spinner /> })`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

export default LoadingSpinner;
